/**
 * This custom hook provides the functionality to save a user with the given parameters.
 */

import {useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useIntl} from "react-intl";

const useEditPlaylist = () => {
    const [saveInProgress, setSaveInProgress] = useState(false)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const history = useHistory();

    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    const save = async (playlistData) => {
        setSaveInProgress(true)

        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/playlists/' + playlistData.key, {
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                idToken: idToken,
                playlistData: {
                    key: playlistData.key,
                    name: playlistData.name,
                    association: playlistData.association,
                    feedbackMode: playlistData.feedbackMode,
                    scoredScenesKeys: playlistData.scoredScenes.map((scoredScene) => scoredScene.key)
                }
            })
        }).then(async (data) => {
            // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
            if (data.status !== 200) {
                throw new Error((await data.json()).status)
            }

            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.playlists.messages.edit.success',
                    defaultMessage: 'Playlist {name} saved.'
                }, {name: playlistData.name}), {
                    variant: 'success',
                    preventDuplicate: true,
                    autoHideDuration: 3000
                });
            history.push("/admin/playlists");
        }).catch((error) => {
            enqueueSnackbar(
                intl.formatMessage({
                    id: 'app.playlists.messages.edit.error',
                    defaultMessage: 'Something went wrong while saving the playlist: {error}'
                }, {error: error.message}), {
                    variant: 'error',
                    preventDuplicate: true,
                    autoHideDuration: 5000
                });
        }).finally(() => {
            setSaveInProgress(false)
        })
    }

    const cancel = () => {
        history.push("/admin/playlists");
    }

    return {save, saveInProgress, cancel}
}
export default useEditPlaylist;